import React from 'react'
import Background from '../Icons/ajgbackgroundc.png';
import logo from '../Icons/AJGSoftwareW32.png';
import LinkedInBadge from '../components/linkedinbadge'

class Main extends React.Component {
    render() {
      return (
      <>

      <div id="holding" style={{backgroundImage:`url(${Background})`}}> 

      <div class='row'>
        <div class='column'>
          <div class='b-column'>
      
      
      
      <div class='row'>
          <img src={logo} alt="AJG Software" />
      </div>
      <div id='strapline' class='row'>
      <h2>Revolutionising industries with cutting-edge software solutions</h2>
      </div>
      <div class='row' style={{height: '100px'}}>
      <p>We are a software consultancy located in Cheshire England offering consultancy, design and development services.</p>

      </div>


      </div>
    </div>
    <div class='column'>
      <div class='g-column'>
      </div>
    </div>
    </div>
      </div>


      <div class='row' id="contact-content">
      <div class='column'>
        </div>
        <div class='column'>
          <p>For sales or general enquiries please contact 
          <a href="mailto:sales@ajgsoftware.com" className="Email">  sales@ajgsoftware.com
          </a></p>
        </div>
        <div class='column' id='social-content' style={{width:'64px'}}>
          <LinkedInBadge />
        </div>

      </div>

    

      </>
      )
    }
  }

  export default Main;
